<script>
  import Header from "../Component/Header.svelte";
  import { doLoading } from "../Api/congress_stores.js";
  import { IMSpezial } from "../Api/congress";
  import { operationStore, query } from "@urql/svelte";
  import ItemIMSpezial from "./IMSpezial/Item.svelte";

  export let congressId;

  const requestPolicy = "network-only";
  let data = {};
  let inProgress = false;

  const congressIMSpezial = operationStore(IMSpezial, { congressId, action: "", actionVeranstaltungId: 0 }, { requestPolicy });

  function processBookingAction(event) {
    const { actionType, actionId } = event.detail;
    congressIMSpezial.variables.action = actionType;
    congressIMSpezial.variables.actionVeranstaltungId = actionId;
    congressIMSpezial.reexecute();
  }

  query(congressIMSpezial);

  congressIMSpezial.subscribe((storeObj) => {
    inProgress = storeObj.fetching;
    if (!inProgress && storeObj.data) {
      console.log("got congress data");
      data = storeObj.data.imspezialdata;

      if (data.startDate) {
        data.startDateObj = new Date();
        data.startDateObj.setTime(Date.parse(data.startDate));
        data.startDateFormated = data.startDateObj.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
      }

      data.eventDates = [];
      data.eventsKeyed = [];

      data.eventlist.forEach(function (myEvent) {
        if (data.eventDates.indexOf(myEvent.startDate + "#" + myEvent.startTime) == -1) {
          data.eventDates.push(myEvent.startDate + "#" + myEvent.startTime);
          data.eventsKeyed[myEvent.startDate + "#" + myEvent.startTime] = {
            startDateFormated: "",
            dayNumber: 0,
            startDateObj: null,
            startTime: myEvent.startTime,
            endTime: myEvent.endTime,
            eventlist: [],
          };

          data.eventsKeyed[myEvent.startDate + "#" + myEvent.startTime].startDateObj = new Date();
          data.eventsKeyed[myEvent.startDate + "#" + myEvent.startTime].startDateObj.setTime(Date.parse(myEvent.startDate));
          data.eventsKeyed[myEvent.startDate + "#" + myEvent.startTime].startDateFormated = data.eventsKeyed[myEvent.startDate + "#" + myEvent.startTime].startDateObj.toLocaleDateString("de-DE", {
            day: "2-digit",
            month: "long",
            year: "numeric",
          });
          data.eventsKeyed[myEvent.startDate + "#" + myEvent.startTime].startDateFormated2 = data.eventsKeyed[myEvent.startDate + "#" + myEvent.startTime].startDateObj.toLocaleDateString("de-DE", {
            day: "numeric",
            month: "long",
            year: "numeric",
          });

          if (data.eventsKeyed[myEvent.startDate + "#" + myEvent.startTime].startDateFormated2 == data.congressDay2 + ". " + data.congressMonth2 + " " + data.congressYear) {
            data.eventsKeyed[myEvent.startDate + "#" + myEvent.startTime].dayNumber = 2;
          } else {
            data.eventsKeyed[myEvent.startDate + "#" + myEvent.startTime].dayNumber = 1;
          }
        }
        data.eventsKeyed[myEvent.startDate + "#" + myEvent.startTime].eventlist.push(myEvent);
      });
      //alert("eD "+eventDates);

      doLoading.update(() => false);
      console.log("process finished");
    }
  });
</script>

<Header {congressId} {...data} />

{#if congressId >= 179}
  <div class="my-3">
    <div>
      <img
        src="/_Resources/Static/Packages/Fpi.ThemeBase/Assets/IM_ONLINE_Kongress_HEADER_AuftaktTalk_TopKeynotes_IMSpezial_620x166pxNoBorder.jpg"
        alt="IM-Spezial"
        class="block w-full border-l-[6px] border-theme-signal sm:col-span-2"
      />
      <section class="border-l-[6px] border-theme-signal sm:col-span-3">
        <span class="py-1 pl-2">
          <p class="pl-2 font-medium uppercase text-theme-minor-600">ANALYTISCH PRAXISNAH UND TOPAKTUELL: DAS KOMPROMISSLOSE FORMAT FÜR INSTITUTIONELLE INVESTOREN</p>
        </span>
      </section>
    </div>
    <p class="mt-5">
      Der Institutional Money Kongress 2025 wartet mit einem besonderen Upgrade auf: Das auf enorme Nachfrage stoßende Analyseformat IM Spezial wird aufgewertet und findet nun mit noch mehr
      Expertinnen und Experten nicht nur an einem, sondern an beiden Kongresstagen statt. Auch haben wir Anregungen aus der Community aufgenommen und das Format noch praxis­näher gestaltet – tiefe
      Analysen und praxisnahe Sessions zum Thema KI, Geopolitik oder Verhandlungstaktik liefern Antworten auf die großen Fragen unserer Zeit.
    </p>
  </div>
{:else if congressId >= 97}
  <h2 class="mt-2.5 text-center text-lg uppercase tracking-wide text-theme-signal">
    <img src="/_Resources/Static/Packages/Fpi.ThemeBase/Assets/inst_money_logo_SPEZIAL_2019_schwarz_transpt500.png" alt="Institutional Money Spezial" class="mx-auto mb-4 block w-full max-w-[375px]" />
    Analytisch kontrovers und topaktuell - <br />
    Das kompromisslose Format für <br />
    Institutionelle Investoren
  </h2>
  {#if data?.startDateObj}
    <h3 class="text-center text-lg font-bold">
      {data.startDateObj.toLocaleDateString("de-DE", { weekday: "short", day: "2-digit", month: "long" })}, {data.startTime} – {data.endTime} Uhr
    </h3>
  {/if}
  <p class="my-4 text-center font-bold">Die aktuell brennendsten Themen der institutionellen Investmentwelt, von unabhängigen Experten präsentiert.</p>
{:else}
  <h2 class="my-3 flex flex-wrap items-center justify-center gap-x-2 text-2xl">
    <img src="/_Resources/Static/Packages/Fpi.ThemeBase/Assets/inst_money_logo_SPEZIAL 2017_rot_transpt.png" alt="Institutional Money Spezial" width="151" class="block w-full max-w-[151px]" />
    <span class="block pt-2.5 text-center"> – das exklusive Info-Format</span>
  </h2>
  {#if data?.startDateObj}
    <h3 class="my-3 text-center text-lg font-bold">
      {data.startDateObj.toLocaleDateString("de-DE", { weekday: "short", day: "2-digit", month: "long" })}, {data.startTime} – {data.endTime} Uhr
    </h3>
  {/if}
  <hr class="hr-gradient" />
  <div class="prose max-w-none">
    <p class="mt-2.5">
      Mittendrin statt nur dabei: <strong>IM Spezial</strong>, das neue Informationsformat am Institutional Money Kongress, behandelt die aktuell brennendsten Themen der institutionellen
      Investmentwelt. Geleitet und moderiert von ausgewählten Experten für das jeweilige Thema, werden für die Praxis relevante Ideen und Lösungen präsentiert. Diskutieren Sie mit Spezialisten und
      Kollegen.
    </p>
  </div>
{/if}

<hr class="hr-gradient mb-2.5" />

<strong>Ihre persönliche Programmübersicht finden Sie hier:</strong>
<a href="/kongress/mein-account#myEvents|overview" class="text-theme-signal"
  ><svg class="svg-inline--fa fa-xl" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
    ><path
      d="M64 64C46.3 64 32 78.3 32 96v64H480V96c0-17.7-14.3-32-32-32H64zM32 192V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V192H32zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 256H384c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H384c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16zM352.2 90.3L384 109.3l31.8-19.1c7.6-4.5 17.4-2.1 21.9 5.5s2.1 17.4-5.5 22l-40 24c-5.1 3-11.4 3-16.5 0l-40-24c-7.6-4.5-10-14.4-5.5-22s14.4-10 21.9-5.5z"
    ></path></svg
  ></a
>

{#if congressId >= 179}
  <br /><br />

  {#each data?.eventDates || [] as eventDatetime}
    <div>
      <p class="bg-red-900 p-1 pl-3 font-semibold text-white">
        {data?.eventsKeyed[eventDatetime].dayNumber}. Tag | {data?.eventsKeyed[eventDatetime].startDateFormated}, {data?.eventsKeyed[eventDatetime].startTime} - {data?.eventsKeyed[eventDatetime]
          .endTime}
      </p>
      {#each data?.eventsKeyed[eventDatetime].eventlist || [] as item}
        <ItemIMSpezial {item} {...data} on:booking={processBookingAction} />
      {/each}
    </div>
  {/each}
{:else}
  <div>
    {#each data?.eventlist || [] as item}
      <ItemIMSpezial {item} {...data} on:booking={processBookingAction} />
    {/each}
  </div>
{/if}
